"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarDaysBetween = void 0;
const parseInputDate_1 = require("../../utils/parseInputDate");
function calendarDaysBetween(startDate, endDate) {
    const startDateTime = (0, parseInputDate_1.parseInputDate)(startDate);
    const endDateTime = (0, parseInputDate_1.parseInputDate)(endDate);
    if (startDateTime.equals(endDateTime)) {
        return 0;
    }
    const difference = endDateTime.diff(startDateTime, 'days').toObject();
    return difference.days;
}
exports.calendarDaysBetween = calendarDaysBetween;
//# sourceMappingURL=index.js.map